export default function BitcoinIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37">
      <defs>
        <clipPath id="clip-path">
          <rect id="Rectangle_697" data-name="Rectangle 697" width="9.225" height="13.589" transform="translate(0 0)" fill="#fff" />
        </clipPath>
      </defs>
      <rect id="Rectangle_703" data-name="Rectangle 703" width="37" height="37" rx="18.5" opacity="0" />
      <g id="Group_1939" data-name="Group 1939" transform="translate(13.303 11.104)">
        <g id="Group_1939-2" data-name="Group 1939" transform="translate(1 -0.005)" clipPath="url(#clip-path)">
          <path
            id="Path_1238"
            data-name="Path 1238"
            d="M8.923,7.807a2.273,2.273,0,0,0-.816-.9,3.95,3.95,0,0,0-1.028-.421,2.963,2.963,0,0,0,1.008-.6A2.509,2.509,0,0,0,8.875,4.05,2.449,2.449,0,0,0,7.4,1.783a3.492,3.492,0,0,0-.935-.257V0H4.978V1.458H3.973V0H2.491V1.458H0V2.934H.377a1.155,1.155,0,0,1,.511.077.426.426,0,0,1,.189.206,1.988,1.988,0,0,1,.055.6V9.768a1.992,1.992,0,0,1-.055.6.406.406,0,0,1-.189.206,1.209,1.209,0,0,1-.511.073H0v1.476H2.491v1.462H3.973V12.123H4.978v1.462H6.46V12.025a4.014,4.014,0,0,0,1.008-.277,2.9,2.9,0,0,0,1.3-1.09A2.835,2.835,0,0,0,9.225,9.1a2.738,2.738,0,0,0-.3-1.288m-3.1-4.5a1.03,1.03,0,0,1,.545.424,1.321,1.321,0,0,1,.189.719,1.3,1.3,0,0,1-.2.715,1.188,1.188,0,0,1-.593.463,3.59,3.59,0,0,1-1.217.153H3.5v-2.6h1.05A4.362,4.362,0,0,1,5.823,3.3m.639,6.464a1.316,1.316,0,0,1-.681.524,3.407,3.407,0,0,1-1.01.126h-.7a1.244,1.244,0,0,1-.428-.042.243.243,0,0,1-.113-.149A3.212,3.212,0,0,1,3.5,9.654V7.345H4.737a3.285,3.285,0,0,1,1.211.168,1.232,1.232,0,0,1,.6.5,1.528,1.528,0,0,1,.2.8,1.615,1.615,0,0,1-.281.955"
            transform="translate(0 0.004)"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
}
